module.exports = __webpack_public_path__ + "static/img/workPass.74789165.png";